import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Eye, Trophy, UserPlus } from 'lucide-react';
import { colors } from '../../constants/theme';
import MatchesView from './MatchesView';
import RankingsView from './RankingsView';
import AdSpace from '../Common/AdSpace';
import { sponsorsConfig } from '../../data/sponsors';
import Header from '../Common/Header';
import useMediaQuery from '../../hooks/useMediaQuery';

const SpectatorView = ({ matches, onSwitchToOrganizer }) => {
  const [currentView, setCurrentView] = useState('matches');

  const isMobileNav = !useMediaQuery('(min-width: 640px)');

  // No desktop os patrocinadores se dividem entre as duas laterais; em telas
  // menores viram uma grade abaixo do conteúdo.
  const isWideScreen = useMediaQuery('(min-width: 1280px)');
  const sponsors = sponsorsConfig.settings.enabled
    ? sponsorsConfig.getActiveSponsors()
    : [];
  const half = Math.ceil(sponsors.length / 2);
  const leftSponsors = sponsors.slice(0, half);
  const rightSponsors = sponsors.slice(half);

  const inscrevaButton = (
    <Link
      to="/inscricao"
      className="px-4 py-2 rounded flex items-center justify-center space-x-2 text-sm font-medium bg-white shadow hover:opacity-90 transition-colors"
      style={{ color: colors.primary }}
    >
      <UserPlus className="h-4 w-4" />
      <span>Inscreva-se</span>
    </Link>
  );

  const viewButton = (view, Icon, label, extraStyle) => (
    <button
      onClick={() => setCurrentView(view)}
      className={`px-4 py-2 rounded flex items-center justify-center space-x-2 transition-colors ${
        currentView === view ? 'text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
      }`}
      style={{ backgroundColor: currentView === view ? colors.primary : 'white', ...extraStyle }}
    >
      <Icon className="h-4 w-4" />
      <span>{label}</span>
    </button>
  );

  return (
    <div className="min-h-screen bg-gray-100">
      <Header
        rightContent={
          <div className="flex items-center gap-6">
            <button
              onClick={onSwitchToOrganizer}
              className="text-sm hover:underline bg-white bg-opacity-20 px-3 py-1 rounded"
            >
              Acesso Organizador
            </button>
          </div>
        }
      />
      <div className="container mx-auto p-6">
        {/* Navegação */}
        {isMobileNav ? (
          <div className="mb-6" style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {/* Linha 0: Inscreva-se centralizado, tamanho natural */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {inscrevaButton}
            </div>
            {/* Linha 1: Partidas e Chaves, mesmo tamanho */}
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              {viewButton('matches', Eye, 'Partidas Atuais', { flex: 1 })}
              {viewButton('rankings', Trophy, 'Chaves e Rankings', { flex: 1 })}
            </div>
          </div>
        ) : (
          <div className="mb-6" style={{ display: 'flex', gap: '0.75rem' }}>
            {inscrevaButton}
            {viewButton('matches', Eye, 'Partidas Atuais')}
            {viewButton('rankings', Trophy, 'Chaves e Rankings')}
          </div>
        )}

        {/* Layout principal - Flexbox ao invés de Grid */}
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          {/* Sidebar Esquerda - APENAS EM TELAS MUITO GRANDES */}
          {isWideScreen && leftSponsors.length > 0 && (
            <div style={{ width: '192px', flexShrink: 0 }}>
              <h3 className="text-sm font-bold text-center mb-4" style={{ color: colors.primary }}>
                Patrocinadores
              </h3>
              <AdSpace sponsors={leftSponsors} />
            </div>
          )}

          {/* Conteúdo Principal - OCUPA TODO ESPAÇO RESTANTE */}
          <div style={{ flex: '1 1 0%', minWidth: '0' }}>
            {currentView === 'matches' && <MatchesView matches={matches} />}
            {currentView === 'rankings' && <RankingsView />}
          </div>

          {/* Sidebar Direita - APENAS EM TELAS MUITO GRANDES */}
          {isWideScreen && rightSponsors.length > 0 && (
            <div style={{ width: '192px', flexShrink: 0 }}>
              <h3 className="text-sm font-bold text-center mb-4" style={{ color: colors.primary }}>
                Patrocinadores
              </h3>
              <AdSpace sponsors={rightSponsors} />
            </div>
          )}
        </div>

        {/* Patrocinadores para telas menores */}
        {!isWideScreen && sponsors.length > 0 && (
          <div style={{ marginTop: '2rem' }}>
            <div className="bg-white rounded-lg p-4 shadow">
              <h3 className="text-center text-sm font-bold mb-4" style={{ color: colors.primary }}>
                Patrocinadores
              </h3>
              <AdSpace variant="grid" sponsors={sponsors} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpectatorView;